import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ShirtIcon } from '../../assets/images/svg/shirt.svg';
import './BottomBanner.css';

export default function BottomBanner() {
  return (
    <div className="bottom-banner">
      <div className="bottom-banner__cta">
        <p className="bottom-banner__text">
          לא מצאתם את מה שחיפשתם?
          <br />
          צוות יום מעשים טובים ישמח לעזור לכם
          <br />
          למצוא את ההתנדבות המתאימה לכם
        </p>
        <Link to="/open-form" className="bottom-banner__link" onClick={() => window.scrollTo(0, 0)}>
          השאירו פרטים
        </Link>
      </div>

      <div className="bottom-banner__shirt">
        <a
          href="https://www.good-deeds-day.org.il/gddtshirts"
          target="_blank"
          rel="noopener noreferrer"
          className="bottom-banner__shirt-link"
        >
          <ShirtIcon className="bottom-banner__shirt-icon" />
          <span>רכשו את החולצה של יום מעשים טובים</span>
        </a>
      </div>
    </div>
  );
}
